import { useMemo } from 'react';

import { useViewer } from '@vimeo/viewer';

/**
 * Hook to determine if the viewer can interact with the content.
 * @param interact - Optional boolean indicating if interaction is allowed.
 * @returns An object containing `canInteract` boolean.
 */
export const useCanInteract = (interact?: boolean) => {
  const { user } = useViewer() ?? {};

  const canInteract = useMemo(() => {
    // Logged out viewer can always interact. If logged in but blocked by the video owner, `interact` will be false
    return !user || (user && Boolean(interact));
  }, [interact, user]);

  return { canInteract };
};
